import React from "react";
import Routes from "../src/Routes";
import "./App.css";
import './styles/animations.css';

function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
